export default function Values() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Safety First',
      description: 'We prioritize safety in every job, following strict industry standards and regulations to protect our team and your property.'
    },
    {
      icon: 'ri-star-line',
      title: 'Quality Workmanship',
      description: 'Our lifetime guarantee reflects our commitment to delivering exceptional quality on every project, no matter the size.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Customer Focus',
      description: 'Your satisfaction is our priority. We listen to your needs and deliver solutions that exceed expectations.'
    },
    {
      icon: 'ri-time-line',
      title: 'Reliability',
      description: 'We show up on time, complete work as promised, and stand behind our commitments with transparent communication.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'We stay current with the latest electrical technologies and techniques to provide modern, efficient solutions.'
    },
    {
      icon: 'ri-team-line',
      title: 'Integrity',
      description: 'Honest pricing, transparent quotes, and ethical practices guide everything we do. No hidden fees, ever.'
    }
  ];

  return (
    <section className="py-14 md:py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#535669] mb-3 md:mb-4">
            Our <span className="text-[#f67f19]">Values</span>
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            The principles that guide our work and define who we are
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {values.map((value, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1"
            >
              <div className="w-12 h-12 md:w-16 md:h-16 bg-[#f67f19]/10 rounded-full flex items-center justify-center mb-4 md:mb-6">
                <i className={`${value.icon} text-[#f67f19] text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#535669] mb-2 md:mb-3">
                {value.title}
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}